import { Component, OnInit, ElementRef ,HostListener, Input, ViewChild,ChangeDetectorRef } from '@angular/core';

import { BuscarService } from 'src/app/services/buscar.service';
import { SituacionService } from 'src/app/services/situacion.service'
import { InterlocutorService } from 'src/app/services/iInterlocutor.service';
import { CotizacionModel } from 'src/app/models/cotizacion.model';
import { NgbModal, NgbModalRef, ModalDismissReasons, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
//Servicios
import { ModalBusquedaInterlocutorComponent } from 'src/app/shared/modals/busqueda/modal-busqueda-interlocutor/modal-busqueda-interlocutor.component';
import { VendedorService } from 'src/app/services/vendedor.service';
import { SucursalService } from 'src/app/services/sucursal.service';
import { ConsultaCotizacionService } from 'src/app/services/comercial-consulta-cotizacion.service';
  import { CommonModule } from '@angular/common';
import { alertaConfirmacion, alertaConfirmacionHTML, basicAlert, basicAlertHTML, filtrarCoincidenciaArrayTransportista, obtenerFechaActual, obtenerFechaSeleccionada, openDescripcion, openObservacion, openReutilizar, setConfigTable, setConfigTableBuscador, timerOut } from 'src/app/shared/utils';
import { SpinnerService } from 'src/app/services/spinner.service';
import { DecimalPipe } from '@angular/common';
import { StorageService } from 'src/app/services/storage.service';
import { Subject } from 'rxjs';
import { SunnatService } from 'src/app/services/sunat-service'
import { GuiaremisionService } from 'src/app/services/guiaremision.service';
import { TrazabilidadComponent } from 'src/app/shared/modals/trazabilidad/trazabilidad.component';
import { CuentaPorCobrarService } from 'src/app/services/cuentaporcobrar.service';
// import { ParamCtaCobEstadoCuenta } from 'src/app/modulos/CuentasPorCobrar/estado-cuentas/ParamCtaCobEstadoCuenta.model';
import { ModalDetallesCuentasComponent } from 'src/app/shared/modals/modal-detalles-cuentas/modal-detalles-cuentas.component';
import * as FileSaver from 'file-saver';
import { DataTableDirective } from 'angular-datatables';
import { FacturaService } from 'src/app/services/factura.service';
import { BoletaService } from 'src/app/services/boleta.service';
import { DocumentoCabeceraService } from 'src/app/services/documento-cabecera.service';
import { TableService } from 'src/app/services/ngtable.service';
import { ConsultaService } from 'src/app/services/consulta.service';
import { MdConsultaClientesComponent } from 'src/app/shared/modals/md-consulta-clientes/md-consulta-clientes.component';
import { MdClienteNuevoComponent } from 'src/app/shared/modals/md-cliente-nuevo/md-cliente-nuevo.component';
import { ModificarClienteComponent } from 'src/app/shared/modals/md-cliente-nuevo/modificar-cliente/modificar-cliente.component'

@Component({
  selector: 'app-md-estado-cuenta',
  templateUrl: './md-estado-cuenta.component.html',
  styleUrls: ['./md-estado-cuenta.component.css']
})
export class MdEstadoCuentaComponent implements OnInit {

  @ViewChild('interlocutor') interlocutor: ElementRef;
  @ViewChild('razon') razon: ElementRef;
  @ViewChild('plazaentrega') plazaentrega: ElementRef;
  @ViewChild(DataTableDirective) dtElement: DataTableDirective;
  intelocutorSeleccionado
  public check: boolean = false;
  //interlocutores: any[] = [];
  disabledInterlocutor: boolean = false;
  buscarInterlocutor: string = 'buscar'
  codTitulo: number = null;
  condicionespago: any[] = [];
  direcciones: any[] = [];
  direccionesenvio: any[] = [];
  contactos: any[] = [];

  resultados: boolean = true;
  formulario: boolean = false;

  dtTrigger: Subject<null> = new Subject();
  dtOptions: any = {};

  public cotizaciones: any = [];

  //VARIABLES SITUACIONES
  public situaciones: any[] = [];
  public newSituaciones: any[] = [];

  //VARIABLES FECHA
  public fechaDesde: any
  public fechaHasta: any;
  //VARIABLES VENDEDOR
  public vendedores: any[] = [];
  public codVendedor: number = -1;

  //VARIABLES SUCURSAL
  public sucursales: any[] = [];
  public codSucursal: number = -1;

  //VARIABLES MOTIVO
  public motivos: any[] = [];
  public codMotivo: number = -1;

  //VARIABLES SUNAT
  public sunatlist: any[] = [];
  public codSunat: number = -1;

  public codEstado: number = -1

  public codLugarEmision: any;
  public sessionInfo: any = {};

  cotizacionChecada: any
  cotizacionSeleccionada: boolean = false
  public trazabilidades: any = [];

  desCondicionPago

  @Input()  codInterlocutor: string = '';
  public desInterlocutor: string = '';
  public interlocutores: any[] = [];
  public ubicacionSeleccionadas = [];
  public _ubicacion: any = 1;

  public params : any;
  public docdestacados: string = "S";
  public radioValue: string = "S";
  public estadocuenta = [];
  public estadocuenta2 = [];
  public arrayObjResumen: any = [];
  public arrayObjResumenMonedas: any = [];
  public camposSoles: boolean = false;
  public camposDolares: boolean = false;
  public camposEuros: boolean = false;
  public viewDetalleDocumento: boolean = false;

  public castobserv: string;
  public simbolo: string;
  public desfidelidad: string;
  public codpag2: number;
  public despag2: string;
  public limcre2: number;
  public limcredis2: number;

  public checkboxValue: boolean = true;
  public descripcionDOcumento: string = "(Documentos pendientes (Incluye letras descontadas))";
  public ubicaciones = [];

  @ViewChild('modalImprimir') modalImprimir: ElementRef;


  public imprimirConLetrasTercero: boolean = false;
  public imprimirConGarantia: boolean = false;


  public tipoImpresion: number;

  constructor(
    private spinnerService: SpinnerService,
    private modalService: NgbModal,
    private interlocutorService: InterlocutorService,
    private ctaCobrarConsultasService: CuentaPorCobrarService,
    private trazabilidadService: ConsultaService,
    private facturaService: FacturaService,
    private boletaService: BoletaService,
    private docCabService: DocumentoCabeceraService,
    private TableService: TableService,
    private modalService2: NgbActiveModal,
    private chRef: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    if(this.codInterlocutor != ''){
      this.onBlurCodInterlocutor(this.codInterlocutor);
    }
    this.getUbicacion();
    this.sessionInfo = JSON.parse(StorageService.getSession());
  }

  onChangeFiltroDocument(filtro: string) {
    this.radioValue = filtro;
  }

  RegresarFromulario() {
    this.resultados = true
    this.formulario = false
  }

  onChange(isChecked: boolean) {
    if (isChecked) {
      this.docdestacados = "S";
      this.descripcionDOcumento = "(Documentos pendientes (Incluye letras descontadas))";
    } else {
      this.docdestacados = "N";
      this.descripcionDOcumento = "(Documentos pendientes)";
    }
  }



  onKeyEnterCodInterlocutor(e: any, codcli: string) {
    let tecla: any = (document.all) ? e.keyCode : e.which;
    if (tecla == 13) {
      this.getDatosCliente(codcli);
    }
  }


  private getUbicacion() {
    this.ctaCobrarConsultasService.ubicaciones().subscribe((response: any) => {
      console.log(response);
      this.ubicaciones = response.body.list;
    });
  }


  consultar() {

    if (this.codInterlocutor == '') {
      basicAlert('Seleccionar un Interlocutor comercial', 'warning', 'Aceptar', null, null, null)
      return;
    }

    this.params.codcli = this.codInterlocutor;
    this.params.solpen = this.radioValue == 'S' ? true : false;
    this.params.incdocdes = this.docdestacados == 'S' ? true : false;
    this.params.numint = null;


    this.ubicacionSeleccionadas.push(this._ubicacion);

    this.params.ubicacion = this.ubicacionSeleccionadas;


    this.arrayObjResumenMonedas = [];
    $("#general").DataTable().clear().destroy();
    this.spinnerService.activarLoading(true);
    this.ctaCobrarConsultasService.getEECC(this.params.codcli, this.params.solpen, this.params.incdocdes, this.params.ubicacion.toString()).subscribe((response: any) => {
      console.log(response);
      this.intelocutorSeleccionado = this.desInterlocutor;
      let objetoMoneda: any = {
        vencidosSoles: 0,
        porvencerSoles: 0,
        vencidosDolares: 0,
        porvencerDolares: 0
      };

      this.resultados = false;
      this.estadocuenta = response.body.lista;
      console.log("response.body.lista ESTADOS DE CUENTA")
      console.log(response.body.lista)
      
      this.lista_temp = response.body.lista;
      this.TableService.tableList = this.lista_temp;
      this.arrayObjResumen = response.body.resumen;
      this.arrayObjResumenMonedas = response.body.resumen;
      // this.arrayObjResumen.forEach(element => {

      //   objetoMoneda.tipdoc = element.tipdoc
      //   objetoMoneda.tipodocumento = element.tipodocumento

      //   element.monedas.forEach((element2: any) => {

      //     if (element2.moneda == 'PEN') {
      //       this.camposSoles = true;
      //       objetoMoneda.monedaSoles = element2.moneda;
      //       objetoMoneda.simboloSoles = element2.simbolo;
      //       objetoMoneda.vencidosSoles = element2.vencidos;
      //       objetoMoneda.porvencerSoles = element2.porvencer;
      //     }

      //     if (element2.moneda == 'USD') {
      //       this.camposDolares = true;
      //       objetoMoneda.monedaDolares = element2.moneda;
      //       objetoMoneda.simboloDolares = element2.simbolo;
      //       objetoMoneda.vencidosDolares = element2.vencidos;
      //       objetoMoneda.porvencerDolares = element2.porvencer;
      //     }

      //     if (element2.moneda == 'EUR') {
      //       this.camposEuros = true;
      //     }

      //   });

      //   this.arrayObjResumenMonedas.push(objetoMoneda);

      // });


      $(".ibox-collapse").click();
    
      
        this.chRef.detectChanges();
        $("#general").DataTable({
          paging: false,
          lengthChange: false,
          searching: false,
          ordering: true,
          info: true,
          // autoWidth: true,
          // scrollX: true,
          // scrollY: "350px",
        });

      //this.chRef.detectChanges();
      //this.FuncionesTSI.createTable('datatableEstadoCuenta', true, true, '400px');

      this.viewDetalleDocumento = false;
      this.estadocuenta2 = [];
      this.spinnerService.activarLoading(false);
    }, err => {
      console.log(err)
      basicAlert('No hay resultados.', 'warning', 'Aceptar', null, null, null);
      this.spinnerService.activarLoading(false);
    });
  }
  consultar2() {

    if (this.codInterlocutor == '') {
      basicAlert('Seleccionar un Interlocutor comercial', 'warning', 'Aceptar', null, null, null)
      return;
    }

    this.params.codcli = this.codInterlocutor;
    this.params.solpen = this.radioValue == 'S' ? true : false;
    this.params.incdocdes = this.docdestacados == 'S' ? true : false;
    this.params.numint = null;


    this.ubicacionSeleccionadas.push(this._ubicacion);

    this.params.ubicacion = this.ubicacionSeleccionadas;


    this.arrayObjResumenMonedas = [];
    $("#resumen").DataTable().clear().destroy();
    this.spinnerService.activarLoading(true);
    this.ctaCobrarConsultasService.getEECC(this.params.codcli, this.params.solpen, this.params.incdocdes, this.params.ubicacion.toString()).subscribe((response: any) => {
      console.log(response);
      this.intelocutorSeleccionado = this.desInterlocutor;
      let objetoMoneda: any = {
        vencidosSoles: 0,
        porvencerSoles: 0,
        vencidosDolares: 0,
        porvencerDolares: 0
      };

      this.resultados = false;
      this.estadocuenta = response.body.lista;
      console.log("response.body.lista ESTADOS DE CUENTA")
      console.log(response.body.lista)
      
      this.lista_temp = response.body.lista;
      this.TableService.tableList = this.lista_temp;
      this.arrayObjResumen = response.body.resumen;
      this.arrayObjResumenMonedas = response.body.resumen;
      // this.arrayObjResumen.forEach(element => {

      //   objetoMoneda.tipdoc = element.tipdoc
      //   objetoMoneda.tipodocumento = element.tipodocumento

      //   element.monedas.forEach((element2: any) => {

      //     if (element2.moneda == 'PEN') {
      //       this.camposSoles = true;
      //       objetoMoneda.monedaSoles = element2.moneda;
      //       objetoMoneda.simboloSoles = element2.simbolo;
      //       objetoMoneda.vencidosSoles = element2.vencidos;
      //       objetoMoneda.porvencerSoles = element2.porvencer;
      //     }

      //     if (element2.moneda == 'USD') {
      //       this.camposDolares = true;
      //       objetoMoneda.monedaDolares = element2.moneda;
      //       objetoMoneda.simboloDolares = element2.simbolo;
      //       objetoMoneda.vencidosDolares = element2.vencidos;
      //       objetoMoneda.porvencerDolares = element2.porvencer;
      //     }

      //     if (element2.moneda == 'EUR') {
      //       this.camposEuros = true;
      //     }

      //   });

      //   this.arrayObjResumenMonedas.push(objetoMoneda);

      // });


      $(".ibox-collapse").click();
    
      
        this.chRef.detectChanges();
        $("#resumen").DataTable({
          paging: false,
          lengthChange: false,
          searching: false,
          ordering: true,
          info: true,
          // autoWidth: true,
          // scrollX: true,
          // scrollY: "350px",
        });

      //this.chRef.detectChanges();
      //this.FuncionesTSI.createTable('datatableEstadoCuenta', true, true, '400px');

      this.viewDetalleDocumento = false;
      this.estadocuenta2 = [];
      this.spinnerService.activarLoading(false);
    }, err => {
      console.log(err)
      basicAlert('No hay resultados.', 'warning', 'Aceptar', null, null, null);
      this.spinnerService.activarLoading(false);
    });
  }
  borrarformulario() {
    this.fechaDesde = null;
    this.fechaHasta = null;
    // this.newSituaciones = []; 
    this.codLugarEmision = -1;
    this.codVendedor = -1;
    this.codSucursal = -1;
    this.codMotivo = -1;
    this.codSunat = -1
    this.fechaDesde = obtenerFechaActual('YYYY-MM-DD')
    this.fechaHasta = obtenerFechaActual('YYYY-MM-DD')
    this.borrarDatosInterlocutor();
    timerOut(10).then((value: any) => {
      if (value) { this.interlocutor.nativeElement.focus(); }
    });
  }

  borrarDatosInterlocutor() {
    this.borrarInterlocutor();

    timerOut(10).then((value: any) => {
      if (value) { this.interlocutor.nativeElement.focus(); }
    });

    this.disabledInterlocutor = false;
    this.buscarInterlocutor = 'buscar';
  }

  borrarInterlocutor() {
    this.codTitulo = null;
    this.codInterlocutor = '';
    this.desInterlocutor = '';
    this.direccionesenvio = [];
    this.condicionespago = [];
    this.interlocutores = [];
    this.direcciones = [];
    this.contactos = [];
  }

  CheckAllOptions() {
    if (this.situaciones.every(val => val.checked == true)) {
      this.situaciones.forEach(val => { val.checked = false });
      this.newSituaciones = [];
    } else {
      this.situaciones.forEach(val => { val.checked = true });
      for (let index = 0; index < this.situaciones.length; index++) {
        if (!this.newSituaciones.includes(this.situaciones[index].situac)) {
          this.newSituaciones.push(this.situaciones[index].situac);
        }
      }
    }
    console.log(this.newSituaciones)
  }

  onBlurCodInterlocutor(codcli: string) {
    if (codcli != '') {
      this.spinnerService.activarLoading(true);
      this.getByCodInterlocutor(codcli);
      this.getDatosCliente(codcli);
    }
  }

  getByCodInterlocutor(codcli: string) {
    this.spinnerService.activarLoading(true);
    this.interlocutorService.obtenerInterlocutor(codcli, true).subscribe((response: any) => {
      this.spinnerService.activarLoading(false);
      this.codTitulo = response.body.codtit;
      this.codInterlocutor = response.body.codcli;
      this.desInterlocutor = response.body.razonc;
      this.simbolo = response.simbolo;
      this.limcre2 = response.limiteCredito;
      this.limcredis2 = response.limiteCredito - response.body.saldo;
      this.codpag2 = response.body.codpag;
      this.despag2 = response.body.despag;
      this.desfidelidad = response.body.desfidelidad;
      this.castobserv = response.body.observ;

      this.disabledInterlocutor = true;
      this.buscarInterlocutor = 'borrar';
    },
      err => {
        console.log(err);
        if (err.status == 404) {
          basicAlert('No se encontró información para el Interlocutor seleccionado', 'warning', 'Aceptar');
        }
        this.spinnerService.activarLoading(false);
      });

  }

  getDatosCliente(codcli: string) {

    let data: any = {
      codcli: codcli,
      numint: 0,
      swmuestramensaje: "N"
    }
    this.spinnerService.activarLoading(true);
    this.interlocutorService.getdatosEECC(data).subscribe((response: any) => {
      this.spinnerService.activarLoading(false);
      this.codInterlocutor = response.body.object.codcli;
      this.desInterlocutor = response.body.object.razonc;
      this.castobserv = response.body.object.castobserv;
      this.simbolo = response.body.object.simbolo;
      this.desfidelidad = response.body.object.desfidelidad;
      this.codpag2 = response.body.object.codpag2;
      this.despag2 = response.body.object.despag2;
      this.limcre2 = response.body.object.limcre2;
      this.limcredis2 = response.body.object.limcre2 - response.body.object.saldo;
      this.disabledInterlocutor = true;
      this.buscarInterlocutor = 'borrar';
    }, err => {
      this.spinnerService.activarLoading(false);
      basicAlert('No se encontró información para el Interlocutor seleccionado', 'warning', 'Aceptar');
    });

  }

  onKeyEnterInterlocutor(e) {
    this.openModalInterlocutor();
    let tecla: any = (document.all) ? e.keyCode : e.which;
    return (tecla != 13);
  }

  openModalInterlocutor() {
    let codcli: string = '';
    let razonc: string = this.desInterlocutor + "%";
    let nombres: string = this.desInterlocutor + "%";
    let dident: string = '';
    let soloactivos: boolean = true;
    let limit: number = 350;
    let offset: number = 0;

    // console.log(razonc)

    if (this.desInterlocutor.length > 0) {
      this.spinnerService.activarLoading(true);
      this.interlocutorService.buscarInterlocutor(codcli, razonc, nombres, dident, soloactivos, limit, offset).subscribe((response: any) => {
        console.log(response);
        this.interlocutores = response.body;
        this.mostrarModalInterlocutor();
      }, err => {
        console.log(err);
        if (err.status == 404) {
          basicAlert('No hay resultados', 'warning', 'Aceptar', null, null, this.razon);
        }
        this.spinnerService.activarLoading(false);
      });
    } else {
      basicAlert('Para activar la ayuda ingresar mínimo 1 caracter', 'warning', 'Aceptar', null, null, this.razon);
      return;
    }

  }

  mostrarModalInterlocutor() {
    const referenciaModal = this.modalService.open(ModalBusquedaInterlocutorComponent, { scrollable: true, windowClass: 'modal-lista-articulos', backdrop: 'static' });
    referenciaModal.componentInstance.cabeceraTexto = 'comercial'
    referenciaModal.componentInstance.interlocutores = this.interlocutores;
    referenciaModal.result.then((data) => {
      console.log(data);
      this.getDatosCliente(data.codcli);
    }, (reason) => {
      console.log(reason);
    });
  }

  exportExcel() {
    basicAlert('Función en desarrollo.', 'warning', 'Aceptar', null, null, null);
  }

  imprimir() {
    basicAlert('Función en desarrollo.', 'warning', 'Aceptar', null, null, null);

  }

  downloadPDFPendientesGarantia() {
    if (this.codInterlocutor == '') {
      basicAlert('Seleccionar un Interlocutor comercial.', 'warning', 'Aceptar', null, null, null);

      return;
    }

    if (this.ubicacionSeleccionadas.length == 0) {
      basicAlert('Seleccionar una o mas ubicaciones.', 'warning', 'Aceptar', null, null, null);


      return;
    }

    // this.hijo = 1;
    this.params.codcli = this.codInterlocutor;
    this.params.solpen = this.radioValue == 'S' ? true : false;
    this.params.incdocdes = this.docdestacados == 'S' ? true : false;
    this.params.ubicacion = this.ubicacionSeleccionadas;

    if (this.ubicacionSeleccionadas.length == 1) {
      // this.params.desUbicacion = this.desUbicacion;
    } else {
      this.params.desUbicacion = "Varias Ubicaciones";
    }
    this.params.descriDesc = this.descripcionDOcumento;

    // this.params.ruc = this.rucUsuario;
    this.params.razonc = this.desInterlocutor;
    // this.params.user = this.Usuario;

    // this.childModalLetrasTerceros.show();
    // this.childModalLetrasTerceros.config = { keyboard: false };
  }

  downloadPDFPendientesRepresentanteLegal() {
    if (this.codInterlocutor == '') {
      basicAlert('Seleccionar un Interlocutor comercial.', 'warning', 'Aceptar', null, null, null);
      return;
    }

    if (this.ubicacionSeleccionadas.length == 0) {
      basicAlert('Seleccionar una o mas ubicaciones.', 'warning', 'Aceptar', null, null, null);

      return;
    }

    // this.hijo = 2;
    this.params.codcli = this.codInterlocutor;
    this.params.solpen = this.radioValue == 'S' ? true : false;
    this.params.incdocdes = this.docdestacados == 'S' ? true : false;
    this.params.ubicacion = this.ubicacionSeleccionadas;

    if (this.ubicacionSeleccionadas.length == 1) {
      // this.params.desUbicacion = this.desUbicacion;
    } else {
      this.params.desUbicacion = "Varias Ubicaciones";
    }
    this.params.descriDesc = this.descripcionDOcumento;

    // this.params.ruc = this.rucUsuario;
    this.params.razonc = this.desInterlocutor;
    // this.params.user = this.Usuario;

    // this.childModalLetrasTerceros.show();
    // this.childModalLetrasTerceros.config = { keyboard: false };
  }


  onChangeLetrastercero() {

    this.imprimirConLetrasTercero

  }

  onChangeGarantia() {

  }

  ImprimirEECC(tipoImpresion: number) {

    this.tipoImpresion = tipoImpresion;

    this.modalService.open(this.modalImprimir, { ariaLabelledBy: 'modal-basic-title', size: 'lg' })
      .result.then((result) => {
        console.log(result);
      }, (reason) => {
        console.log(reason);
      });
  }



  anular(data: any) {
    basicAlert('Función en desarrollo.', 'warning', 'Aceptar', null, null, null);
  }

  eliminar(data: any) {
    basicAlert('Función en desarrollo.', 'warning', 'Aceptar', null, null, null);
  }

  ImprimirPDFD() {


    this.params.garantia = this.imprimirConGarantia ? 1 : 2;
    this.params.letrastercero = this.imprimirConGarantia ? 1 : 2;

    console.log(this.tipoImpresion);

    if (this.tipoImpresion != null && this.tipoImpresion == 1) {


      this.params.incdocdes = (this.params.incdocdes != null && this.params.incdocdes) ? "S" : "N";
      this.params.solpen = (this.params.solpen != null && this.params.solpen) ? "S" : "N";

      this.spinnerService.activarLoading(true);
      this.interlocutorService.getdownloadPDFPendientesGarantia(this.params)
        .subscribe((response: any) => {
          this.spinnerService.activarLoading(false);
          if (response.byteLength > 0) {
            let file = new Blob([response], { type: 'application/pdf' });
            var fileURL = URL.createObjectURL(file);
            // FileSaver.saveAs(fileURL, 'Estado de Cuenta Pendientes con Garantia' + '.pdf');
            window.open(fileURL);
          }
          else {
            basicAlert('No hay resultados', 'warning', 'Aceptar', null, null, null);
          }
        }, error => {
          this.spinnerService.activarLoading(false);
          if (error.status == 400) {
            basicAlert('Error de servicio, estamos trabajando en ello...', 'warning', 'Aceptar', null, null, null);
          }
        });


    } else if (this.tipoImpresion != null && this.tipoImpresion == 2) {

      this.params.incdocdes = (this.params.incdocdes != null && this.params.incdocdes) ? "S" : "N";
      this.params.solpen = (this.params.solpen != null && this.params.solpen) ? "S" : "N";

      this.spinnerService.activarLoading(true);
      this.interlocutorService.getdownloadPDFPendientesRepresentanteLegal(this.params)
        .subscribe((response: any) => {
          this.spinnerService.activarLoading(false);
          if (response.byteLength > 0) {
            let file = new Blob([response], { type: 'application/pdf' });
            var fileURL = URL.createObjectURL(file);
            
            // FileSaver.saveAs(fileURL, 'Estado de Cuenta Pendientes con Representante Legal' + '.pdf');
            window.open(fileURL);


          }
          else {
            basicAlert('No hay resultados', 'warning', 'Aceptar', null, null, null);
          }
        }, error => {
          this.spinnerService.activarLoading(false);
          if (error.status == 400) {
            basicAlert('Error de servicio, estamos trabajando en ello...', 'warning', 'Aceptar', null, null, null);
          }
        });


    }

  }

  onClick(data: any): void {
    this.esttemp = data;
  }

  trazabilidad(data: any) {
    console.log(data)
    this.esttemp = data;
    this.spinnerService.activarLoading(true);
    this.trazabilidadService.getListTrazabilidadDocumentos(data.numint).subscribe((response: any) => {
      if (response.status != 404) {
        //if (response.list) {
        this.trazabilidades = response.body.list;
        console.log(this.trazabilidades);
        this.mostrarModalTrazabilidad();

        //this.childModalTrazabilidad.show();
        //this.childModalTrazabilidad.config = { keyboard: false };
        this.spinnerService.activarLoading(false);
        //} else {
        //    basicAlert('No hay resultados', 'warning', 'Aceptar', null, null, null);
        //    this.spinnerService.activarLoading(false);
        //  }
      } else {
        this.spinnerService.activarLoading(false);
        basicAlert('Servicio no disponible', 'warning', 'Aceptar', null, null, null);
      }
    });
    // basicAlert('Función en desarrollo.', 'warning', 'Aceptar', null, null, null);
    //this.FuncionesTSI.destroyTable('ModalDatatableTrazabilidad');

    /*
      this.spinnerService.activarLoading(true);
      this.trazabilidadService.getListTrazabilidadDocumentos(data.numint).subscribe((response: any) => {
        console.log(response.body.list);

        if (response.status != 404) {
          this.trazabilidades = response.body.list;
          console.log("this.trazabilidades");
          console.log(this.trazabilidades);
          this.mostrarModalTrazabilidad();

          this.spinnerService.activarLoading(false);

        } else {
          basicAlert('Servicio no disponible', 'warning', 'Aceptar', null, null, null);
          this.spinnerService.activarLoading(false);
        }
      });
    */
  }

  mostrarModalTrazabilidad() {
    const referenciaModal = this.modalService.open(TrazabilidadComponent, { scrollable: true, windowClass: 'modal-lg-mytheme', backdrop: 'static' });
    //referenciaModal.componentInstance.cabeceraTexto = 'comercial'
    referenciaModal.componentInstance.trazabilidades = this.trazabilidades;
    referenciaModal.result.then((data) => {
      console.log(data);
      //this.getByCodInterlocutor(data.codpro)
    }, (reason) => {
      console.log(reason);
    });
  }


  onChangeCotizacion(coti: any) {

    this.cotizacionChecada = coti;
    console.log(this.cotizacionChecada);
    this.cotizacionSeleccionada = true;
    ////////////////////////////////////

    this.params.codcli = this.codInterlocutor;
    this.params.solpen = this.radioValue //== 'S' ? true : false;
    this.params.incdocdes = this.docdestacados //== 'S' ? true : false;
    this.params.numint = coti.numint;

    this.ubicacionSeleccionadas.push(this._ubicacion);

    this.params.ubicacion = this.ubicacionSeleccionadas;

    this.spinnerService.activarLoading(true);

    //  DETALLE DOCUMENTOS
    this.ctaCobrarConsultasService.getCtaCobCsltEstadoCuenta(this.params).subscribe((response: any) => {
      console.log(response);
      this.estadocuenta2 = response.body.list;
      this.spinnerService.activarLoading(false);

    }, err => {
      this.spinnerService.activarLoading(false);
      basicAlert('No se encontró detalles para el Interlocutor seleccionado', 'warning', 'Aceptar');

    });


  }

  esttemp = {
    numint: '',
  };

  detalles(est: any) {
    console.log(est)
    this.esttemp = est;
    //  DETALLE DOCUMENTOS
    this.ctaCobrarConsultasService.getDetalleEECC(this.params.codcli, this.params.solpen, this.params.incdocdes, this.params.ubicacion.toString(), est.numint).subscribe((response: any) => {
      console.log("detalle cargado")
      console.log(response);
      // this.estadocuenta2 = response.body.list;
      const referenciaModal = this.modalService.open(ModalDetallesCuentasComponent, { scrollable: true, windowClass: 'modal-large-detalle', backdrop: 'static' });
      referenciaModal.componentInstance.detalles = response.body.list;
      referenciaModal.componentInstance.tipo = "Cobrar";

      this.spinnerService.activarLoading(false);

    }, err => {
      this.spinnerService.activarLoading(false);
      basicAlert('No se encontró detalles para el Interlocutor seleccionado', 'warning', 'Aceptar');

    });
  }

  viewPdf(doc: any) {
    if (doc.byteLength > 0) {
      let file = new Blob([doc], { type: 'application/pdf' });
      var fileURL = URL.createObjectURL(file);
      window.open(fileURL);
    } else {
      basicAlert('Archivo no disponible..', 'warning', 'Aceptar', null, null, null);

    }
  }

  imprimirComprobante(data:any){
console.log(data)
console.log(this.sessionInfo)
    if (data.tipdoc == 1) {
      this.spinnerService.activarLoading(true);

      this.facturaService.download_pdf(3, data.numint, this.sessionInfo.cia).subscribe((response: any) => {
        this.spinnerService.activarLoading(false);
        console.log(response);
        if (response.byteLength > 0) {
          let file = new Blob([response], { type: "application/pdf" });
          var fileURL = URL.createObjectURL(file);
          window.open(fileURL);
        } else {
          basicAlert('No hay resultados.', 'warning', 'Aceptar', null, null, null);
        }
      }, err => {
        console.log(err)
        this.spinnerService.activarLoading(false);
        basicAlert('Impresión de documento no disponible.', 'warning', 'Aceptar', null, null, null);
      });

    } else if (data.tipdoc == 3) {
      this.spinnerService.activarLoading(true);
      this.boletaService.download_pdf(3, data.numint, this.sessionInfo.cia).subscribe(((response: any) => {
        this.spinnerService.activarLoading(false);
        this.viewPdf(response);
      }), err => {
        this.spinnerService.activarLoading(false);
      })
    } else {
      this.spinnerService.activarLoading(true);
      this.docCabService.download_pdf(data.tipdoc, this.sessionInfo.id_cia, data.numint).subscribe(((resp: any) => {
        this.spinnerService.activarLoading(false);
        if (resp.byteLength > 0) {
          let file = new Blob([resp], { type: 'application/pdf' });
          var fileURL = URL.createObjectURL(file);
          window.open(fileURL);
        } else {
          basicAlert('Archivo no disponible..', 'warning', 'Aceptar', null, null, null);
        }
      }), err => {
        this.spinnerService.activarLoading(false);
      })
    }


  }
  _csearchTerm: string='';
  get csearchTerm(): string {
    
    return this._csearchTerm;
  }

  set csearchTerm(val: string) {
    this._csearchTerm = val;
    this.estadocuenta = this.cfilter(val);
    // this.totalLengthOfCollection = this.cfilterClient.length;
  }

  cfilter(v: string) {
    console.log("this.lista_temp")
    console.log(this.lista_temp)

    if(this._csearchTerm == ''){
      this.estadocuenta = this.lista_temp;
      return this.estadocuenta;
    }
    console.log(this._csearchTerm)
    return this.TableService.getTable().filter(
    x => x.abrevi?.toLowerCase().indexOf(v.toLowerCase()) !== -1  ||
    x.docume?.toString().toLowerCase().indexOf(v.toString().toLowerCase()) !== -1 || 
    x.tdocumento?.toString().toLowerCase().indexOf(v.toString().toLowerCase()) !== -1 || 
    x.femisi?.toString().toLowerCase().indexOf(v.toString().toLowerCase()) !== -1 || 
    x.fvenci?.toString().toLowerCase().indexOf(v.toString().toLowerCase()) !== -1 );

  }
  lista_temp;
  onChange2(val: any){
    console.log("this._csearchTerm")
    console.log(this._csearchTerm)
    
    timerOut(1000).then((value: any) => {
      if (value) {
        if(this._csearchTerm == '' || this._csearchTerm == null ){
          console.log("this.movimientos_temp")
          console.log(this.lista_temp)
          this.estadocuenta = this.lista_temp;
        }
      }
    });

  }
  cerrar(): void {
    this.modalService2.dismiss('canceling');
  }

  openModalCliente() {
    let referenciaModal2
    referenciaModal2 = this.modalService.open(MdConsultaClientesComponent, {
      scrollable: true,
      windowClass: 'md-full-size',
      backdrop: 'static'
    });
    referenciaModal2.componentInstance.codIntelocutor = this.disabledInterlocutor == true ? this.codInterlocutor : null;
    referenciaModal2.result.then((data) => {
    }, (reason) => {
      console.log(reason);
    });
  }
  RouteClienteNuevo() {
    //this.router.navigateByUrl('/modulo/archivos/proveedor/lista')
    const referenciaModal = this.modalService.open(ModificarClienteComponent, { scrollable: true, windowClass: 'md-full-size', backdrop: 'static' });
    referenciaModal.componentInstance.codInterlocutor1 = this.disabledInterlocutor == true ? this.codInterlocutor : null;
    referenciaModal.result.then((data) => {
      console.log(" data devuelta");
      console.log(data);
    }, (reason) => {
      console.log(reason);
    });
  }

}
